/**
 * Works as cart upsells for the cart drawer
 * Uses Shopifys related/complimentary recom engine
 * Tries to distribute recommendations evenly across the latest items in the cart
 * ...as Shopifys engine only accepts one product ID at a time
 *
 * Injects it's results into existing recom container populated by manually selected items
 * @param {*} event 
 * @returns void
 */
 
const debug = false;

const CART_CHANGE_EVENT = 'cart:change';
const CART_CHANGE_TIMEOUT_MS = 50; // timeout needed to wait for carousel init
const CART_DRAWER_SELECTOR = '#cart-drawer';
const CART_DRAWER_OPEN_EVENT = 'dialog:after-show';

const cartDrawer = document.querySelector(CART_DRAWER_SELECTOR);

const log = (message) => {
  if (!debug) return;
  console.log('upsells.js', message);
}

const addLoadingElements = (upsellsOutput, LIMIT, LOADING_CARD_SELECTOR) => {
  for (let i = 0; i < LIMIT; i++) {
    const loadingElement = document.createElement('div');
    loadingElement.classList.add(LOADING_CARD_SELECTOR.replace('.', ''));
    
    upsellsOutput.append(loadingElement);
  }
}

const removeLoadingElements = (upsellsOutput, LOADING_CARD_SELECTOR) => {
  const loadingElements = upsellsOutput.querySelectorAll(LOADING_CARD_SELECTOR);
  loadingElements.forEach(element => element.remove());
}

const removeLoadingStateFromManualItems = () => {
  const manualElements = document.querySelectorAll('.loading');
  manualElements.forEach(el => el.classList.remove('loading'));
}

const recommedUpsells = async (event) => {  
  // Container to add fetched cards
  const upsellsOutput = document.querySelector('[data-cart-upsells-output]');
  
  if (!upsellsOutput) {
    console.error('Upsells output not found');
    removeLoadingStateFromManualItems();
    return;
  }
  
  const { intent, count, useLoadingState } = upsellsOutput.dataset;
  
   // Selector of card in response
  const CARD_SELECTOR = '.horizontal-product-card';
  const LOADING_CARD_SELECTOR = `${CARD_SELECTOR}--loading`;
  
  // Max amount of recommendations to show
  const RECOM_THRESHOLD = parseInt(count, 10) || 5;
  
  // We want to base recommendations off the latest items added to the cart
  let latestItemsInCart = [];  
  
  // Client can add fixed recoms via the customizer. Those are prioritized.
  const manualRecommendations = upsellsOutput.querySelectorAll(`${CARD_SELECTOR}`);
  
  // Recoms to find
  const LIMIT = Math.max(RECOM_THRESHOLD - manualRecommendations.length, 0);
  
   // Section to fetch for recommendations
  const SECTION_ID = 'cart-drawer-recom-upsells';
  const INTENT = intent || 'related';
    
  log({event,upsellsOutput,LIMIT,INTENT});
    
  if (LIMIT <= 0 || INTENT === 'none') {
    console.error({LIMIT, INTENT});
    removeLoadingStateFromManualItems();
    return;
  };
  
  if (useLoadingState == 'true') {
    addLoadingElements(upsellsOutput, LIMIT, LOADING_CARD_SELECTOR);
  }
  
  if (event) {
    latestItemsInCart = event.detail.cart.items.reverse().slice(0, RECOM_THRESHOLD);
  } else {
    await fetch(`${Shopify.routes.root}cart.js`, { cache: "reload" })
      .then(response => response.json())
      .then(data => {
        latestItemsInCart = data.items.reverse().slice(0, RECOM_THRESHOLD);
      });
  }
  
  // Distribute the amount of items to get recommendations off each LineItem
  const baseFetchLimit = Math.floor(LIMIT / latestItemsInCart.length);
  const leftoverAfterEqualDistribution = LIMIT % latestItemsInCart.length;
  
  /**
   * Increase initial fetch limit to account for potential duplicates
   * These will be filtered out later
   */
  const initialFetchMultiplier = 2;
  const increasedFetchLimit = (baseFetchLimit + 1) * initialFetchMultiplier;
  
  /**
   * Fetch recommendations for a LineItem
   * @param {*} productId ID of the product to get recommendations for
   * @param {*} limit Amount of recommendations to fetch related to this LineItem
   * @returns HTMLElement[] - list of product cards
   */
  const fetchProductCards = async (productId, limit) => {
    const response = await fetch(`${window.Shopify.routes.root}recommendations/products?product_id=${productId}&limit=${limit}&section_id=${SECTION_ID}&intent=${INTENT}`);
    const text = await response.text();
    const html = document.createElement('div');
    html.innerHTML = text;
    return [...html.querySelectorAll(CARD_SELECTOR)];
  };
  
  // Generate a Promise for each LineItem to fetch recommendations
  const fetchPromises = latestItemsInCart.map((item, index) => {
    /**
     * Amount of recommendations to fetch for this LineItem
     * ...including excess to account for potential duplicates
     */
    const fetchLimit = increasedFetchLimit + (index < leftoverAfterEqualDistribution ? 1 : 0);
    return fetchProductCards(item.product_id, fetchLimit);
  });
  
  const toggleUpsellDrawer = (show) => {
    if (show) {
      cartDrawer.classList.add('cart-drawer--has-upsells');
    } else {
      cartDrawer.classList.remove('cart-drawer--has-upsells');
    }
  }

  try {
    /**
     * All product cards fetched for each LineItem including
     * excess to account for potential duplicates
     */
    const allProductCards = await Promise.all(fetchPromises);
    const flattenedProductCards = allProductCards.flat();

    const uniqueProductIds = new Set();
    const uniqueSortedProductCards = flattenedProductCards
    
      // Sort the cards by price (assuming price is stored in a data attribute like data-price)
      .sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price))
      
      // Filter out duplicates
      .filter(card => {
        const { productId } = card.dataset;
        if (uniqueProductIds.has(productId)) {
          return false;
        } else {
          uniqueProductIds.add(productId);
          return true;
        }
      });

    // Ensure we meet the exact LIMIT after filtering (unless there are not enough unique cards)
    const finalProductCards = uniqueSortedProductCards.slice(0, LIMIT);
    
    log({finalProductCards, manualRecommendations});
    toggleUpsellDrawer(finalProductCards.length + manualRecommendations.length);
      
    if (useLoadingState == 'true') {
      removeLoadingElements(upsellsOutput, LOADING_CARD_SELECTOR);
    }
    
    // Remove any existing [data-ajax] elements from the container
    upsellsOutput.querySelectorAll('[data-ajax]').forEach(element => element.remove());
    
    upsellsOutput.append(...finalProductCards);
    
    removeLoadingStateFromManualItems();
  } catch (error) {
    console.error('Failed to fetch product recommendations:', error);
    removeLoadingStateFromManualItems();
  }
}

log({CART_CHANGE_EVENT,CART_DRAWER_OPEN_EVENT, CART_CHANGE_TIMEOUT_MS, cartDrawer});

document.addEventListener(CART_CHANGE_EVENT, async (event) => {
  setTimeout(async () => {
    await recommedUpsells(event);
  }, CART_CHANGE_TIMEOUT_MS);
});

if (cartDrawer) {
  cartDrawer.addEventListener(CART_DRAWER_OPEN_EVENT, async () => {
    setTimeout(async () => {
      await recommedUpsells();
    }, CART_CHANGE_TIMEOUT_MS);
  });
}